<template>
<div class="columns is-gapless">
  <div class="column is-four-fifths">
    <gmap-map :center="center" :zoom="zoom" style="width: 100%;position: absolute;top:0;bottom:0;" ref="map">
      <gmap-info-window :options="infoWindow.options" :position="infoWindow.pos" :opened="infoWindow.native && infoWindow.open" @closeclick="infoWindow.open=false" class="card">
        <div class="card" v-if="infoWindow.native && infoWindow.content" :key="index" v-for="(m, index) in [infoWindow.content]">
          <header class="card-header">
            <p class="card-header-title">
              {{m.name}}
            </p>
            <span class="card-header-icon" :class="m.counters.isFull || m.counters.free===0 || m.counters.fullAt && $moment(m.counters.fullAt).diff($moment(), 'minutes') < 10
            ? 'has-text-danger' : m.counters.fullAt && $moment(m.counters.fullAt).diff($moment(), 'minutes') < 60
            ? 'has-text-warning' : 'has-text-primary'">
              {{m.counters.free}}
              <span class="icon">
                <i class="fab fa-product-hunt" aria-hidden="true"></i>
              </span>
            </span>
          </header>
          <div class="card-content">
            <div class="content has-text-centered">
              <p :class="m.counters.isFull || m.counters.free===0 || m.counters.fullAt && $moment(m.counters.fullAt).diff($moment(), 'minutes') < 10
              ? 'has-text-danger' : m.counters.fullAt && $moment(m.counters.fullAt).diff($moment(), 'minutes') < 60
              ? 'has-text-warning' : 'has-text-primary'"
                :hid="$moment(m.counters.fullAt).diff($moment(), 'minutes')">
                <template v-if="m.counters.isFull || m.counters.free===0">Complet</template>
                <template v-else-if="m.counters.fullAt && $moment(m.counters.fullAt).diff($moment(), 'minutes') < 60">Complet
                  {{m.counters.fullAt | moment("from", "now")}}</template>
                <template v-else="v-else">Libre</template>
              </p>
              <address v-html="splitAddress(m.address)"></address>
              <span class="icon">
                <i class="fa fa-wheelchair" title="Accès personne à mobilité réduite"></i>
              </span>
              <span class="icon">
                <i class="fa fa-motorcycle" title="Accès deux roues"></i>
              </span>
              <span class="icon">
                <i class="fa fa-plug" title="Accès deux roues"></i>
              </span>
              <span class="icon">
                <i class="fa fa-moon-o" title="Accès de nuit"></i>
              </span>
              <span class="icon">
                <i class="fa fa-text-height" title="Hauteur maximale : 1.90m"></i>
              </span>
              <span>1.90<small>m
                </small>
              </span>
            </div>
          </div>
          <footer class="card-footer">
            <a class="card-footer-item has-text-success js_book" disabled="disabled">Réserver</a>
            <label for="parking_list_chk" class="card-footer-item">
              <a @click="getRoute(m)">Itinéraire</a>
            </label>
          </footer>
        </div>
      </gmap-info-window>
      <gmap-marker :ref="m.address" :key="index" v-for="(m, index) in markers" :opacity="index>4 ? 0.5 : 1" :icon="{
        url: m.status ? require('@/assets/markers/'+m.status+'.png') : '',
        size: {width: 28, height: 28, f: 'px', b: 'px'},
        scaledSize: {width: 28, height: 28, f: 'px', b: 'px'},
        origin: {x:0, y:0},
        anchor: {x:14, y:14}}"
        :position="positionFromCoordinates(m.coordinates)" :clickable="true" @click="toggleInfoWindow(m, index)"></gmap-marker>
      <gmap-marker :position="myPosition"></gmap-marker>
      <mpMarker :marker="{position: center}" />
      <!-- <gmap-circle :center="center" :radius="500" :options="{
        fillColor: '#0067b1',
        strokeColor: '#59ABE3',
        fillOpacity: 0.2}"></gmap-circle> -->
      <gmap-polyline v-for="segment in segments" :key="segment.data.cigm_ref+segment.data.segment_id" :color="segment.data.trimmed" :options="{path: segment.coordinates.path.map(function (pat) {return getLatLng(pat)}),
          strokeColor: (segment.data.entity.split('-', 1)[0].replace('nightly', 'impact') === 'segment') ? segment.data.color : '#' + segment.data.color,
          strokeWeight: 2,
          icons: [{
            icon: {
              path: 0 ,
              scale: 2,
              strokeColor: (segment.data.entity.split('-', 1)[0].replace('nightly', 'impact') === 'segment') ? segment.data.color : '#' + segment.data.color
            },
            offset: polylineOffset
          }],
          zIndex: segment.data.severity}"
        v-if="filters.showTraficLayer"></gmap-polyline>
    </gmap-map>
  </div>
  <input type="checkbox" style="display:none" id="parkings_list_chk" v-model="showParkingsMobile" />
  <div class="column is-one-fifth" id="parkings_list" v-if="infoWindow.native || !infoWindow.content">
    <div id="search_box" class="is-paddingless">
      <div class="card is-marginless z-1">
        <div class="card-content">
          <!-- <div id="search_button" class="button is-info is-circle"> <b-icon pack="fas" icon="search"></b-icon> </div> -->
          <div>
            <b-icon pack="fas" icon="map-marker-alt" custom-class="fa-fw"></b-icon>
            <span>{{currentPlace ? currentPlace.name + ', ' : " : "}}
              {{currentPlace ? currentPlace.vicinity :
        position ? position.formatted_address : 'Entrer une destination'}}</span>
          </div>
          <div>
            <b-icon pack="fas" icon="stopwatch" custom-class="fa-fw"></b-icon>
            <span>Stationner
              {{parkingDuration}}
              Heure{{parkingDuration>1?'s':''}}</span>
          </div>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item has-text-success" @click="isComponentModalActive=true">
            <b-icon pack="fas" icon="map-marker-alt" custom-class="fa-fw"></b-icon>
            <span>Rechercher</span>
          </a>
          <a class="card-footer-item has-text-primary" @click="isFiltersModalActive=!isFiltersModalActive">
            <b-icon pack="fa" icon="filter" custom-class="fa-fw"></b-icon>
            <span>Filtrer</span>
          </a>
        </footer>
      </div>
    </div>
    <div class="vertical_deck">
      <div class="vertical_list">
        <div class="card" :key="index" v-for="(m, index) in markers">
          <header class="card-header" for="parking_details_chk" @click="infoWindow.content=m" :class="m.counters.isFull || m.counters.free===0 || m.counters.fullAt && $moment(m.counters.fullAt).diff($moment(), 'minutes') < 10
        ? 'is-danger' : m.counters.fullAt && $moment(m.counters.fullAt).diff($moment(), 'minutes') < 60
        ? 'is-warning' : 'is-primary'">
            <p class="card-header-title">
              {{m.name}}
              <small v-if="!isNaN(m.distance)">&nbsp;-
                {{m.distance}}m</small>
            </p>
            <span class="card-header-icon">
              {{m.counters.free}}
              <span class="icon">
                <i class="fab fa-product-hunt" aria-hidden="true"></i>
              </span>
            </span>
          </header>
          <div class="card-content" @click="infoWindow.content=m">
            <div class="content has-text-centered">
              <p :class="m.counters.isFull || m.counters.free===0 || m.counters.fullAt && $moment(m.counters.fullAt).diff($moment(), 'minutes') < 10
            ? 'has-text-danger' : m.counters.fullAt && $moment(m.counters.fullAt).diff($moment(), 'minutes') < 60
            ? 'has-text-warning' : 'has-text-primary'"
                :hid="$moment(m.counters.fullAt).diff($moment(), 'minutes')">
                <template v-if="m.counters.isFull || m.counters.free===0 || $moment(m.counters.fullAt).diff($moment(), 'minutes') < 0">Complet</template>
                <template v-else-if="m.counters.fullAt && $moment(m.counters.fullAt).diff($moment(), 'minutes') < 60">Complet
                  {{m.counters.fullAt | moment("from", "now")}}</template>
                <template v-else="v-else">Libre
                </template>
                <br />
                <small v-if="m.fare">{{ m.fare.cost }}EUR pour
                  {{parkingDuration}}
                  heure{{parkingDuration>1?'s':''}}
                  de stationnement</small>
              </p>
              <address v-html="splitAddress(m.address)"></address>
              <span class="icon" v-if="m.filters.accessible">
                <i class="fas fa-wheelchair" title="Places réservées personne à mobilité réduite"></i>
              </span>
              <span class="icon" v-if="m.filters.cctv">
                <i class="fas fa-video" title="Vidéosurveillance"></i>
              </span>
              <span class="icon" v-if="m.filters.electricCharge">
                <i class="fas fa-bolt" title="Places réservées recharge véhicule électrique"></i>
              </span>
              <span class="icon" v-if="m.filters.lpg">
                <i class="fas fa-tint" title="Accès autorisé aux véhicules GPL"></i>
              </span>
              <span class="icon" v-if="m.filters.mobee">
                <i class="fab fa-slideshare" title="Parking partenaire Mobee"></i>
              </span>
              <span class="icon is-small">
                <i class="fas fa-arrows-alt-v" title="Hauteur maximale"></i>
              </span><span>{{m.filters.maxHeight}}
                <small>m</small>
              </span>
            </div>
          </div>
          <footer class="card-footer">
            <a class="card-footer-item has-text-success" @click="infoWindow.content=m">Plus d'infos</a>
            <a class="card-footer-item has-text-primary" @click="getRoute(m);showParkingsMobile=false;">
              <label for="parking_list_chk" class="is-clickable">
                Itinéraire
              </label>
            </a>
          </footer>
        </div>
      </div>
    </div>
  </div>
  <div class="column is-one-fifth" id="parking_details" v-if="infoWindow.content">
    <div class="vertical_hand">
      <div class="card" :key="index" v-for="(m, index) in [infoWindow.content]">
        <header class="card-header z-1" :class="m.counters.isFull || m.counters.free===0 || m.counters.fullAt && $moment(m.counters.fullAt).diff($moment(), 'minutes') < 10
      ? 'is-danger' : m.counters.fullAt && $moment(m.counters.fullAt).diff($moment(), 'minutes') < 60
      ? 'is-warning' : 'is-primary'">
          <p class="card-header-title">
            {{m.name}}
          </p>
          <span class="card-header-icon">
            {{m.counters.free}}
            <span class="icon">
              <i class="fab fa-product-hunt" aria-hidden="true"></i>
            </span>
          </span>
        </header>
        <div class="card-content">
          <div class="content">
            <p :class="m.counters.isFull || m.counters.free===0 || m.counters.fullAt && $moment(m.counters.fullAt).diff($moment(), 'minutes') < 10
          ? 'has-text-danger' : m.counters.fullAt && $moment(m.counters.fullAt).diff($moment(), 'minutes') < 60
          ? 'has-text-warning' : 'has-text-primary'"
              :hid="$moment(m.counters.fullAt).diff($moment(), 'minutes')">
              <template v-if="m.counters.isFull || m.counters.free===0 || $moment(m.counters.fullAt).diff($moment(), 'minutes') < 0">Complet</template>
              <template v-else-if="m.counters.fullAt && $moment(m.counters.fullAt).diff($moment(), 'minutes') < 60">Complet
                {{m.counters.fullAt | moment("from", "now")}}</template>
              <template v-else="v-else">Libre</template>
            </p>
            <p>
              <address v-html="splitAddress(m.address)"></address>
            </p>
            <div v-if="m.filters.accessible" class="columns is-mobile">
              <b-icon class="column is-2" icon="wheelchair" custom-size="fa-fw"></b-icon>
              <span class="column is-8">Places réservées personne à mobilité réduite</span>
            </div>
            <div v-if="m.filters.cctv" class="columns is-mobile">
              <b-icon class="column is-2" icon="video" custom-size="fa-fw"></b-icon>
              <span class="column is-8">Vidéosurveillance</span>
            </div>
            <div v-if="m.filters.electricCharge" class="columns is-mobile">
              <b-icon class="column is-2" icon="bolt" custom-size="fa-fw"></b-icon>
              <span class="column is-8">Places réservées recharge véhicule électrique</span>
            </div>
            <div v-if="m.filters.lpg" class="columns is-mobile">
              <b-icon class="column is-2" icon="tint" size="is-small" custom-size="fa-fw"></b-icon>
              <span class="column is-8">Accès autorisé aux véhicules GPL</span>
            </div>
            <div v-if="m.filters.mobee" class="columns is-mobile">
              <b-icon class="column is-2" icon="slideshare" pack="fab" size="is-small" custom-size="fa-fw"></b-icon>
              <span class="column is-8">Parking partenaire Mobee</span>
            </div>
            <div v-if="m.filters.maxHeight" class="columns is-mobile">
              <b-icon class="column is-2" icon="arrows-alt-v" size="is-small" icon-size="fa-fw"></b-icon>
              <span class="column is-8">Hauteur maximale : {{m.filters.maxHeight}}
                <small>m
                </small>
              </span>
            </div>
          </div>
        </div>
        <footer class="card-footer">
          <label for="parking_list_chk" class="card-footer-item">
            <a @click="getRoute(m);infoWindow.content=null;showParkingsMobile=false">Itinéraire</a>
          </label>
          <a class="card-footer-item has-text-danger" @click="infoWindow.content=null">Fermer</a>
        </footer>
      </div>
    </div>
  </div>
  <nav class="navbar is-fixed-bottom" style="background-color: transparent;">
    <div class="container is-flex">
      <div class="is-flex" style="margin: auto;">
        <div class="navbar-end">
          <div class="navbar-item is-hidden-desktop">
            <label class="button is-link" for="parkings_list_chk">
              <b-icon :icon="showParkingsMobile ? 'times' : 'list'" size="is-small">
              </b-icon>
              <span>Menu</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  </nav>
  <b-modal :active.sync="isFiltersModalActive" :width="640" has-modal-card="has-modal-card">
    <div class="modal-card" style="width: auto">
      <div class="modal-card-body">
        <section>
          <b-field :label="'Hauteur minimale : '+filters.maxHeight+'m'">
            <b-input v-model="filters.maxHeight" custom-class="slider is-fullwidth is-primary" type="range" min="1.60" max="2.60" step="0.10"></b-input>
          </b-field>
          <b-field>
            <b-switch v-model="filters.accessible">
              Parkings accessibles
            </b-switch>
          </b-field>
          <b-field>
            <b-switch v-model="filters.electricCharge">
              Véhicules électriques
            </b-switch>
          </b-field>
          <b-field>
            <b-switch v-model="filters.lpg">
              Véhicules GPL
            </b-switch>
          </b-field>
          <b-field>
            <b-switch v-model="filters.mobee">
              Parkings partenaires Mobee
            </b-switch>
          </b-field>
          <b-field label="Calques">
            <b-switch v-model="filters.showTraficLayer" v-if="!traficDisabled">
              Afficher l'état du trafic
            </b-switch>
          </b-field>
          <b-field>
            <b-switch v-model="filters.showParkings">
              Afficher les Parkings
            </b-switch>
          </b-field>
        </section>
      </div>
      <footer class="modal-card-foot">
        <button class="button is-success" @click="validPlace();isFiltersModalActive=false">Appliquer</button>
        <button class="button" type="button" @click="isFiltersModalActive=false">Fermer</button>
      </footer>
    </div>
  </b-modal>
  <b-modal :active.sync="isComponentModalActive" :width="640" has-modal-card="has-modal-card">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Où souhaitez-vous aller ?</p>
      </header>
      <section class="modal-card-body">
        <b-field label="Destination">
          <b-field>
            <div class="control is-clearfix">
              <gmap-autocomplete :options="{componentRestrictions: {country: 'mc'}}" class="input" @place_changed="setPlace"></gmap-autocomplete>
            </div>
            <p class="control">
              <button class="button is-primary" @click="geolocate();isComponentModalActive=false;">
                <b-icon pack="fas" icon="crosshairs"></b-icon>
              </button>
            </p>
          </b-field>
        </b-field>
        <b-field label="Durée de stationnement">
          <b-field>
            <b-input type="number" v-model="parkingDuration" />
            <p class="control">
              <span class="button is-static">Heure{{parkingDuration>1?'s':''}}</span>
            </p>
          </b-field>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <b-field>
          <button class="button is-success" @click="validPlace();isComponentModalActive=false">Trouver un parking</button>
          <button class="button" type="button" @click="isComponentModalActive=false">Afficher la carte</button>
        </b-field>
      </footer>
    </div>
  </b-modal>
</div>
</template>

<script>
import {
  loaded
} from 'vue2-google-maps';

import mpMarker from './Marker';

export default {
  name: 'GoogleMap',
  props: {
    defaultTraficLayer: {
      type: [String],
      default: ''
    }
  },
  components: {
    mpMarker
  },
  data () {
    return {
      traficDisabled: false,
      segments: [],
      offsetCount: 0,
      polylineOffset: 100,
      isComponentModalActive: String(this.defaultTraficLayer).toLowerCase() !== 'trafic',
      isFiltersModalActive: false,
      showParkingsMobile: false,
      myPosition: {
        lat: 43.73841760000001,
        lng: 7.42461579999997
      },
      center: {
        lat: 43.73841760000001,
        lng: 7.42461579999997
      },
      zoom: 15,
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
      places: [],
      trafic: [],
      parkingDuration: 1,
      currentPlace: null,
      position: null,
      parkings: null,
      fares: [],
      currentParking: null,
      filters: {
        accessible: false,
        cctv: false,
        electricCharge: false,
        lpg: false,
        maxHeight: 1.60,
        mobee: false,
        showTraficLayer: String(this.defaultTraficLayer).toLowerCase() === 'trafic',
        showParkings: true
      },
      googleMapsInitialized: false,
      directionsService: null,
      directionsDisplay: null,
      geocoder: null,
      parcDetailsIsOpen: false,
      infoWindow: {
        native: false,
        options: {
          pixelOffset: {
            width: 0,
            height: -15
          }
        },
        pos: null,
        content: null,
        currentMidx: null,
        isOpen: false
      }
    };
  },
  computed: {
    google () {
      return window.google;
    },
    markers () {
      const statusOrder = {
        free: 0,
        soon: 1,
        full: 2
      };
      if (this.parkings && this.googleMapsInitialized && this.center) {
        const filtmapsorted = this.parkings.map((x) => {
          const park = x;
          park.distance = parseInt(this.google.maps.geometry.spherical.computeDistanceBetween(
            new this.google.maps.LatLng(x.coordinates.latitude, x.coordinates.longitude),
            new this.google.maps.LatLng(this.center.lat, this.center.lng)
          ), 10);
          park.fare = this.fares.find(fare => fare.parc === park.id);
          if (park.status) return park;
          if (park.counters.isFull || park.counters.free === 0 || (park.counters.fullAt && this.$moment(park.counters.fullAt).diff(this.$moment(), 'minutes') < 10)) {
            park.status = 'full';
          } else if (park.counters.fullAt && this.$moment(park.counters.fullAt).diff(this.$moment(), 'minutes') < 60) {
            park.status = 'soon';
          } else {
            park.status = 'free';
          }
          return park;
        }).filter((x) => {
          let state = true;
          if (this.filters.accessible) {
            state = state && x.filters.accessible;
          }
          if (this.filters.cctv) {
            state = state && x.filters.cctv;
          }
          if (this.filters.electricCharge) {
            state = state && x.filters.electricCharge;
          }
          if (this.filters.lpg) {
            state = state && x.filters.lpg;
          }
          if (this.filters.mobee) {
            state = state && x.filters.mobee;
          }
          if (!this.filters.showParkings) {
            return false;
          }
          state = state &&
            parseFloat(x.filters.maxHeight, 10) >= parseFloat(this.filters.maxHeight, 10);
          return state;
        }).sort((a, b) => statusOrder[a.status] - statusOrder[b.status] || a.distance - b.distance);
        return filtmapsorted;
      }
      return this.parkings;
    }
  },
  mounted () {
    // Dégueulasse
    const head = document.getElementsByTagName('head')[0];
    // Save the original method
    // const insertBefore = head.insertBefore;
    const {
      insertBefore
    } = head;
    // Replace it!
    head.insertBefore = (newElement, referenceElement) => {
      const wrkNewElement = newElement;
      if (newElement.href && newElement.href.indexOf('https://fonts.googleapis.com/css?family=Roboto') === 0) {
        // Encore un peu de vomi pour finir votre tartine de caca ?
        wrkNewElement.href = 'https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,400,600';
      }
      insertBefore.call(head, wrkNewElement, referenceElement);
    };
    loaded.then(() => {
      this.googleMapsInitialized = true; // define this property in data
      this.directionsService = new this.google.maps.DirectionsService();
      this.directionsDisplay = new this.google.maps.DirectionsRenderer();
      this.geocoder = new this.google.maps.Geocoder();
      this.directionsDisplay.setMap(this.$refs.map.$mapObject);
      this.geolocate();
    });
    this.$http.get('parc/list').then((result) => {
      this.parkings = result.data.data;
    });
    this.$http.get('traffic').then((result) => {
      if (result && result.data && result.data.data) {
        this.segments = result.data.data;
      } else {
        this.traficDisabled = true;
      }
    });
    window.setInterval(() => {
      this.offsetCount = (this.offsetCount + 1) % 100;
      this.polylineOffset = `${this.offsetCount}%`;
    }, 20);
  },
  methods: {
    getLatLng (pat) {
      return {
        lat: pat[0],
        lng: pat[1]
      };
    },
    splitAddress (value) {
      if (!value) return '';
      const val = value.toString();
      const splits = val.split(' - ');
      return `${this.$t('map.accessBy')} ${splits[1]}`;
    },
    setPlace (place) {
      // this.$http.post('weblog', {
      //   level: 'info',
      //   method: 'setPlace',
      //   message: 'Setting place',
      //   place
      // });
      this.tempPlace = place;
    },
    validPlace () {
      this.$http.get('parc/fare', { params: { duration: this.parkingDuration } }).then((result) => {
        this.fares = result.data.data.fares;
      });
      this.currentPlace = this.tempPlace;
      if (this.currentPlace) {
        this.center = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
      } else {
        this.center = {
          lat: 43.73841760000001,
          lng: 7.42461579999997
        };
      }
    },
    toggleInfoWindow (marker, idx) {
      this.infoWindow.pos = this.positionFromCoordinates(marker.coordinates);
      this.infoWindow.content = marker;

      // check if its the same marker that was selected if yes toggle
      if (this.infoWindow.currentMidx === idx) {
        this.infoWindow.open = !this.infoWindow.open;
      } else {
        this.infoWindow.open = true;
        this.infoWindow.currentMidx = idx;
      }
    },
    getRoute (parking) {
      const vm = this;
      if (!this.position) {
        this.position = {
          geometry: {
            location: this.myPosition
          }
        };
      }
      this.$http.post('weblog', {
        level: 'info',
        method: 'getRoute',
        message: 'Asking route',
        origin: this.position.geometry.location,
        destination: this.positionFromCoordinates(parking.coordinates)
      });
      // .then(response => console.log(response))
      //   .catch(e => console.log(e));
      vm.directionsService.route({
        origin: this.position.geometry.location, // Can be coord or also a search query
        destination: this.positionFromCoordinates(parking.coordinates),
        travelMode: 'DRIVING'
      }, (response, status) => {
        if (status === 'OK') {
          this.$http.post('weblog', {
            level: 'info',
            method: 'getRoute',
            message: 'Route response',
            origin: this.position.geometry.location,
            destination: this.positionFromCoordinates(parking.coordinates),
            response,
            status
          });
          // .then(response1 => console.log(response1))
          //   .catch(e => console.log(e));
          vm.directionsDisplay.setDirections(response); // draws the polygon to the map
        } else {
          this.$http.post('weblog', {
            level: 'info',
            method: 'getRoute',
            message: 'Directions request failed',
            origin: this.position.geometry.location,
            destination: this.positionFromCoordinates(parking.coordinates),
            response,
            status
          });
          // .then(response2 => console.log(response2))
          //    .catch(e => console.log(e));
        }
      });
    },
    geolocate () {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          if (position && position.coords && position.coords.latitude) {
            this.myPosition = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            if (!this.currentPlace) {
              this.center = {
                lat: parseFloat(position.coords.latitude),
                lng: parseFloat(position.coords.longitude)
              };
            }
            this.$http.post('weblog', {
              level: 'info',
              method: 'geolocate',
              message: 'navigator.geolocation activated',
              myPosition: this.myPosition
            });
            this.geocoder.geocode({
              location: this.myPosition
            }, (results, status) => {
              if (status === 'OK') {
                if (results[0]) {
                  [this.position] = results;
                }
              }
            });
          }
          // .then(response => console.log(response))
          //   .catch(e => console.log(e));
        });
      } else {
        this.$http.post('weblog', {
          level: 'warning',
          method: 'geolocate',
          message: 'No navigator.geolocation',
          center: this.center
        });
        // .then(response => console.log(response))
        //   .catch(e => console.log(e));
      }
    },
    positionFromCoordinates (coordinates) {
      return {
        lat: parseFloat(coordinates.latitude),
        lng: parseFloat(coordinates.longitude)
      };
    }
  }
};
</script>
<!-- <style lang="sass" src="@/sass/components/_gmap.sass"></style> -->
<!-- <style src="http://cdn.parkings.mc/css/bulma.min.css"></style> <style src="http://cdn.parkings.mc/css/main.css"></style> -->
<style lang="sass" src="@/sass/main.sass"></style>
<style lang="sass">
.is-clickable
  cursor: pointer
</style>
<!--<style lang="sass"> @import ~@fortawesome/fontawesome-free-webfonts/scss/variables $fa-font-path : "~@fortawesome/fontawesome-free-webfonts/webfonts" @import ~@fortawesome/fontawesome-free-webfonts/scss/fontawesome @import ~@fortawesome/fontawesome-free-webfonts/scss/fa-regular @import ~@fortawesome/fontawesome-free-webfonts/scss/fa-solid @import ~@fortawesome/fontawesome-free-webfonts/scss/fa-brands </style> -->



// WEBPACK FOOTER //
// src/components/McMap.vue